export const height = '100vh';
export const width = '100vw';

export const appBar = {
	height: '40px',
};

export const main = {
	height: `calc(${height} - ${appBar.height})`,
};

export const pageTitle = {
	height: '50px',
	top: appBar.height,
};

export const content = {
	height: `calc(${main.height} - ${pageTitle.height})`,
	top: pageTitle.height,
};

export const drawer = {
	width: '250px',
};

export const alert = {
	height: '120px',
	width: '390px',
};

export const alertDialog = {
	height: '80px',
	width: '450px',
};

export const searchButton = {
	width: '80px',
};

export const okButton = {
	width: '80px',
};

export const redirectButton = {
	boxMinWidth: '400px',
	buttonWidth: '160px',
	marginLeft: 3,
};
